import { isoToDateAndTime } from "utilz/helpers";

export const chipOptionsBody = [
  { id: "teamMember", label: "Added by", value: "team-member" },
  { id: "assignee", label: "Assignee", value: "assignee" },
  { id: "billableStatus", label: "Billable status", value: "billable-status" },
  { id: "budgetedHours", label: "Budgeted hours", value: "budgeted-hours" },
  { id: "chatMessage", label: "Reply message", value: "chat-message" },
  { id: "address1", label: "Company address", value: "address1" },
  { id: "brandName", label: "Company brand name", value: "Company-brand-name" },
  { id: "country", label: "Company country", value: "country" },
  { id: "location", label: "Company location", value: "location" },
  { id: "companyName", label: "Company name", value: "company-name" },
  { id: "state", label: "Company state", value: "state" },
  { id: "contractName", label: "Contract name", value: "contract-name" },
  { id: "customerCode", label: "Customer code", value: "customer-code" },
  { id: "customerName", label: "Customer name", value: "customer-name" },
  {
    id: "vanityCustomerPortalUrl",
    label: "Customer portal url",
    value: "vanity-customer-portal-url",
  },
  {
    id: "customerPortalLink",
    label: "Customer portal link",
    value: "customerPortalLink",
  },
  { id: "impact", label: "Impact", value: "impact" },
  { id: "note", label: "Note", value: "note" },
  { id: "oldStatus", label: "Previous status", value: "old-status" },
  { id: "sender", label: "Replying team member", value: "sender" },
  { id: "slaName", label: "SLA name", value: "sla-name" },
  { id: "serviceOwner", label: "Service owner", value: "service-owner" },
  { id: "newStatus", label: "Status", value: "new-status" },
  { id: "tag", label: "Tags", value: "tag" },
  { id: "serviceUId", label: "Ticket ID", value: "service-id" },
  { id: "priority", label: "Ticket priority", value: "priority" },
  { id: "serviceSubType", label: "Sub-category", value: "service-sub-type" },
  { id: "serviceSummary", label: "Ticket summary", value: "service-summary" },
  { id: "serviceType", label: "Service category", value: "service-type" },
  { id: "serviceAge", label: "Ticket age", value: "service-age" },
  { id: "createdAt", label: "Ticket created date", value: "created-at" },
  { id: "description", label: "Ticket description", value: "description" },
  {
    id: "serviceEndTime",
    label: "Ticket estimated end date",
    value: "service-end-time",
  },
  {
    id: "scheduledTime",
    label: "Ticket scheduled date",
    value: "scheduled-time",
  },
  { id: "source", label: "Ticket source", value: "source" },
  { id: "urgency", label: "Urgency", value: "urgency" },
  { id: "userName", label: "User full name", value: "user-name" },
  { id: "userFirstName", label: "User first name", value: "user-first-name" },
  { id: "viewService", label: "View ticket", value: "view-service" },
  { id: "participants", label: "Participants", value: "participants" },
  { id: "workRole", label: "Billing role", value: "work-role" },
  { id: "workType", label: "Work type", value: "work-type" },
  { id: "verificationCode", label: "Code", value: "verificationCode" },
  { id: "teamsAppLink", label: "Teams app link", value: "teams-app-link" },
  { id: "iOSAppLink", label: "iOS app link", value: "ios-app-link" },
  {
    id: "androidAppLink",
    label: "Android app link",
    value: "android-app-link",
  },
  {
    id: "windowsAppDownloadLink",
    label: "Windows app download link",
    value: "windows-app-download-link",
  },
  {
    id: "macOSAppDownloadLink",
    label: "macOS app download link",
    value: "macos-app-download-link",
  },
];

export const chipOptionsSubject = [
  { id: "teamMember", label: "Added by", value: "team-member" },
  { id: "assignee", label: "Assignee", value: "assignee" },
  { id: "billableStatus", label: "Billable status", value: "billable-status" },
  { id: "budgetedHours", label: "Budgeted hours", value: "budgeted-hours" },
  { id: "chatMessage", label: "Reply message", value: "chat-message" },
  { id: "address1", label: "Company address", value: "address1" },
  { id: "brandName", label: "Company brand name", value: "Company-brand-name" },
  { id: "country", label: "Company country", value: "country" },
  { id: "location", label: "Company location", value: "location" },
  { id: "companyName", label: "Company name", value: "company-name" },
  { id: "state", label: "Company state", value: "state" },
  { id: "contractName", label: "Contract name", value: "contract-name" },
  { id: "customerCode", label: "Customer code", value: "customer-code" },
  { id: "customerName", label: "Customer name", value: "customer-name" },
  {
    id: "customerPortalLink",
    label: "Customer portal link",
    value: "customerPortalLink",
  },
  { id: "impact", label: "Impact", value: "impact" },
  { id: "note", label: "Note", value: "note" },
  { id: "oldStatus", label: "Previous status", value: "old-status" },
  { id: "sender", label: "Replying team member", value: "sender" },
  { id: "slaName", label: "SLA name", value: "sla-name" },
  { id: "serviceOwner", label: "Service owner", value: "service-owner" },
  { id: "newStatus", label: "Status", value: "new-status" },
  { id: "tag", label: "Tags", value: "tag" },
  { id: "serviceUId", label: "Ticket ID", value: "service-id" },
  { id: "priority", label: "Ticket priority", value: "priority" },
  { id: "serviceSubType", label: "Sub-category", value: "service-sub-type" },
  { id: "serviceSummary", label: "Ticket summary", value: "service-summary" },
  { id: "serviceType", label: "Service category", value: "service-type" },
  { id: "serviceAge", label: "Ticket age", value: "service-age" },
  { id: "createdAt", label: "Ticket created date", value: "created-at" },
  { id: "description", label: "Ticket description", value: "description" },
  {
    id: "serviceEndTime",
    label: "Ticket estimated end date",
    value: "service-end-time",
  },
  {
    id: "scheduledTime",
    label: "Ticket scheduled date",
    value: "scheduled-time",
  },
  { id: "source", label: "Ticket source", value: "source" },
  { id: "urgency", label: "Urgency", value: "urgency" },
  { id: "userName", label: "User full name", value: "user-name" },
  { id: "userFirstName", label: "User first name", value: "user-first-name" },
  { id: "viewService", label: "View ticket", value: "view-service" },
  { id: "participants", label: "Participants", value: "participants" },
  { id: "workRole", label: "Billing role", value: "work-role" },
  { id: "workType", label: "Work type", value: "work-type" },
];

export const chipOptionsBodyPreview = [
  {
    id: "serviceUId",
    label: "Ticket ID",
    value: "service-id",
    previewValue: "ST-001",
  },
  {
    id: "viewService",
    label: "View ticket",
    value: "view-service",
    previewValue: "View ticket",
  },
  {
    id: "participants",
    label: "Participants",
    value: "participants",
    previewValue: "John Miller",
  },
  {
    id: "serviceSummary",
    label: "Ticket summary",
    value: "service-summary",
    previewValue: "Unable to connect to VPN",
  },
  {
    id: "description",
    label: "Ticket description",
    value: "description",
    previewValue:
      "User is unable to connect to the corporate VPN from home. Issue started after a recent system update. Verified network settings, but the problem persists.",
  },
  {
    id: "userFirstName",
    label: "User first name",
    value: "user-first-name",
    previewValue: "John",
  },
  {
    id: "customerName",
    label: "Customer name",
    value: "customer-name",
    previewValue: "Alpax Solutions Inc.",
  },
  {
    id: "customerCode",
    label: "Customer code",
    value: "customer-code",
    previewValue: "ALPAX0002",
  },
  {
    id: "userName",
    label: "User full name",
    value: "user-name",
    previewValue: "John Miller",
  },
  {
    id: "oldStatus",
    label: "Previous status",
    value: "old-status",
    previewValue: "New",
  },
  {
    id: "newStatus",
    label: "Status",
    value: "new-status",
    previewValue: "Assigned",
  },
  {
    id: "assignee",
    label: "Assignee",
    value: "assignee",
    previewValue: "Emma Thomas",
  },
  {
    id: "teamMember",
    label: "Added by",
    value: "team-member",
    previewValue: "Michael James",
  },
  {
    id: "priority",
    label: "Ticket priority",
    value: "priority",
    previewValue: "Critical",
  },
  {
    id: "tag",
    label: "Tags",
    value: "tag",
    previewValue: "VPN, Remote Access, Connectivity",
  },
  {
    id: "source",
    label: "Ticket source",
    value: "source",
    previewValue: "IT-Connect Mobile",
  },
  { id: "impact", label: "Impact", value: "impact", previewValue: "High" },
  { id: "urgency", label: "Urgency", value: "urgency", previewValue: "High" },
  {
    id: "workType",
    label: "Work type",
    value: "work-type",
    previewValue: "Remote",
  },
  {
    id: "workRole",
    label: "Billing role",
    value: "work-role",
    previewValue: "Technician",
  },
  {
    id: "serviceAge",
    label: "Ticket age",
    value: "service-age",
    previewValue: "10 hours 3 mins",
  },
  {
    id: "createdAt",
    label: "Ticket created date",
    value: "created-at",
    previewValue: "Current date and time",
  },
  {
    id: "slaName",
    label: "SLA name",
    value: "sla-name",
    previewValue: "Standard Remote SLA - Critical",
  },
  {
    id: "contractName",
    label: "Contract name",
    value: "contract-name",
    previewValue: "Alpax Annual Remote Support",
  },
  {
    id: "serviceOwner",
    label: "Service owner",
    value: "service-owner",
    previewValue: "Sophia Jones",
  },
  {
    id: "budgetedHours",
    label: "Budgeted hours",
    value: "budgeted-hours",
    previewValue: "3 hours",
  },
  {
    id: "location",
    label: "Company location",
    value: "location",
    previewValue: "New York",
  },
  {
    id: "serviceType",
    label: "Service category",
    value: "service-type",
    previewValue: "Network",
  },
  {
    id: "serviceSubType",
    label: "Sub-category",
    value: "service-sub-type",
    previewValue: "VPN Issue",
  },
  {
    id: "serviceEndTime",
    label: "Ticket estimated end date",
    value: "service-end-time",
    previewValue: "Current date and time",
  },
  {
    id: "serviceHealth",
    label: "Health",
    value: "service-health",
    previewValue: "Passed",
  },
  {
    id: "billableStatus",
    label: "Billable status",
    value: "billable-status",
    previewValue: "Billable",
  },
  {
    id: "note",
    label: "Added note",
    value: "note",
    previewValue:
      "As a first step, could you try the following:<br /><br />&nbsp;&nbsp;&nbsp;&nbsp;1. Fully quit the VPN client (don't just disconnect)<br />&nbsp;&nbsp;&nbsp;&nbsp;2. Restart your machine<br />&nbsp;&nbsp;&nbsp;&nbsp;3. Reopen the VPN client and attempt to connect<br /><br />If the issue persists, please share a screenshot of the error message you see and let me know approximately when the last successful connection was.<br /><br />I'll keep this ticket open and monitor for your response.",
  },
  {
    id: "chatMessage",
    // label: "Chat Message",
    label: "Reply message",
    value: "chat-message",
    previewValue: `Thanks for reporting this. I can see you're unable to connect to the corporate VPN after the 
recent update.`,
  },
  {
    id: "companyName",
    label: "Company name",
    value: "company-name",
    previewValue: "",
  },
  {
    id: "brandName",
    label: "Company brand name",
    value: "brand-name",
    previewValue: "Company Brand Name", //fetch real data
  },
  {
    id: "address1",
    label: "Company address",
    value: "address1",
    previewValue: "Company Address", // fetch real data
  },
  {
    id: "address2",
    label: "Address line 2",
    value: "address2",
    previewValue: "",
  },
  {
    id: "country",
    label: "Company country",
    value: "country",
    previewValue: "country", // fetch real data
  },
  { id: "state", label: "Company state", value: "state", previewValue: "" },
  {
    id: "companyLogo",
    label: "Company logo",
    value: "company-logo",
    previewValue: "",
  },

  {
    id: "sender",
    label: "Replying team member",
    value: "sender",
    previewValue: "Sender",
  }, // fetch real data

  {
    id: "scheduledTime",
    label: "Ticket scheduled date",
    value: "scheduled-time",
    previewValue: "", // current time
  },
  {
    id: "redirectButton",
    label: "Link button",
    value: "link-button",
    previewValue: "Activate Account",
  },
  {
    // id: "redirect_url",
    id: "redirectUrl",
    label: "Redirect link",
    value: "redirect-url",
    previewValue: "https://www.sample_link.com",
  },
  {
    id: "verificationCode",
    label: "Code",
    value: "verificationCode",
    previewValue: "000000",
  },
  {
    id: "vanityCustomerPortalUrl",
    label: "Customer portal link",
    value: "vanity-customer-portal-url",
    previewValue: "https://www.customer-portal.com",
  },
  {
    id: "customerPortalLink",
    label: "Customer portal link",
    value: "customerPortalLink",
    previewValue: "View ticket",
  },
  {
    id: "teamsAppLink",
    label: "Teams app link",
    value: "teams-app-link",
    previewValue: "https://www.teams-app.com",
  },
  {
    id: "iOSAppLink",
    label: "iOS app link",
    value: "ios-app-link",
    previewValue: "https://www.ios-app.com",
  },
  {
    id: "androidAppLink",
    label: "Android app link",
    value: "android-app-link",
    previewValue: "https://www.android-app.com",
  },
  {
    id: "windowsAppDownloadLink",
    label: "Windows app download link",
    value: "windows-app-download-link",
    previewValue: "https://www.windows-app-download.com",
  },
  {
    id: "macOSAppDownloadLink",
    label: "macOS app download link",
    value: "macos-app-download-link",
    previewValue: "https://www.macos-app-download.com",
  },
];

// Flow-aware chip helpers ----------------------------------------------------
// Default labels (in chipOptionsBody/Subject/Preview) are ticket-flavored.
// For project/task flows, swap the "Ticket" prefix on the affected ids only.
export type EmailTemplateFlow = "ticket" | "project" | "task";

const FLOW_SPECIFIC_CHIP_IDS = new Set<string>([
  "serviceUId",
  "serviceSummary",
  "description",
  "priority",
  "serviceAge",
  "source",
  "createdAt",
  "scheduledTime",
  "serviceEndTime",
  "viewService",
  "customerPortalLink",
]);

const FLOW_PREFIX: Record<EmailTemplateFlow, string> = {
  ticket: "Ticket",
  project: "Project",
  task: "Task",
};

// Replace any whole-word occurrence of "Ticket"/"ticket" with the flow's
// equivalent, preserving the original casing (so "Ticket ID" → "Project ID"
// and "View ticket" → "View project").
const swapTicketWord = (text: string, flow: EmailTemplateFlow): string => {
  const replacement = FLOW_PREFIX[flow];
  return text.replace(/\b(T|t)icket\b/g, (_, firstChar) =>
    firstChar === "T" ? replacement : replacement.toLowerCase(),
  );
};

export const applyFlowToChips = <
  T extends { id: string; label: string; previewValue?: unknown },
>(
  chips: T[],
  flow: EmailTemplateFlow = "ticket",
): T[] => {
  if (flow === "ticket") return chips;
  return chips.map((chip) => {
    if (!FLOW_SPECIFIC_CHIP_IDS.has(chip.id)) return chip;
    const next: T = { ...chip, label: swapTicketWord(chip.label, flow) };
    if (typeof chip.previewValue === "string") {
      (next as { previewValue: string }).previewValue = swapTicketWord(
        chip.previewValue,
        flow,
      );
    }
    return next;
  });
};

export const getFlowFromServiceType = (
  serviceType?: string | null,
): EmailTemplateFlow => {
  if (serviceType === "projects") return "project";
  if (serviceType === "tasks") return "task";
  return "ticket";
};

// Display order for the chip-picker dropdown. Items not in this list fall
// through to alphabetical order at the bottom. Edit this list to reorder.
const CHIP_DISPLAY_ORDER: string[] = [
  "serviceUId", // 2 Ticket ID
  "serviceSummary", // 3 Ticket summary
  "description", // 4 Ticket description
  "userFirstName", // 5 User first name
  "priority", // 6 Ticket priority
  "assignee", // 7 Assignee
  "newStatus", // 8 Status
  "vanityCustomerPortalUrl", // 9 Customer portal link
  "customerPortalLink", // New Customer portal link
  "serviceAge", // 10 Ticket age
  "serviceType", // 11 Service category
  "serviceSubType", // 12 Sub-category
  "tag", // 13 Tags
  "userName", // 14 User full name
  "urgency", // 15 Urgency
  "impact", // 16 Impact
  "source", // 17 Ticket source
  "oldStatus", // 18 Previous status
  "sender", // 19 Replying team member
  "serviceOwner", // 20 Service owner
  "teamMember", // 21 Added by
  "companyName", // 22 Company name
  "brandName", // 23 Company brand name
  "address1", // 24 Company address
  "country", // 25 Company country
  "state", // 26 Company state
  "location", // 27 Company location
  "customerCode", // 28 Customer code
  "contractName", // 29 Contract name
  "createdAt", // 30 Ticket created date
  "scheduledTime", // 31 Ticket scheduled date
  "serviceEndTime", // 32 Ticket estimated end date
  "slaName", // 33 SLA name
  "billableStatus", // 34 Billable status
  "budgetedHours", // 35 Budgeted hours
  "workType", // 36 Work type
  "workRole", // 37 Work role
];

export const sortChipsByDisplayOrder = <
  T extends { id: string; label: string },
>(
  chips: T[],
): T[] => {
  const idx = new Map(CHIP_DISPLAY_ORDER.map((id, i) => [id, i]));
  return [...chips].sort((a, b) => {
    const ai = idx.get(a.id);
    const bi = idx.get(b.id);
    if (ai !== undefined && bi !== undefined) return ai - bi;
    if (ai !== undefined) return -1;
    if (bi !== undefined) return 1;
    return a.label.localeCompare(b.label);
  });
};
// ----------------------------------------------------------------------------

export const getChipPreviewOptions = (
  previewHelperData: {
    timezone: string;
    resourceDetails: any; // Fixed typo from resourceDatails
    companyDetails: any;
  },
  flow: EmailTemplateFlow = "ticket",
) => {
  const newDate: any = new Date();
  const scheduledTime = isoToDateAndTime({
    isodate: newDate,
    timezone: previewHelperData?.timezone,
    format: "DD MMMM YYYY, hh:mm A",
  });

  // Create a mapping object for easier lookup
  const valueMap: any = {
    scheduledTime: scheduledTime,
    sender: `${previewHelperData.resourceDetails?.first_name || ""} ${
      previewHelperData.resourceDetails?.last_name || ""
    }`.trim(),
    country: previewHelperData.companyDetails?.country_name || "Country",
    state: previewHelperData.companyDetails?.state_name || "State",
    address1: previewHelperData.companyDetails?.address1 || "Address",
    brandName: previewHelperData.companyDetails?.brand_name || "Brand Name",
    companyName:
      previewHelperData.companyDetails?.company_name || "Company Name",
    serviceEndTime: scheduledTime || "",
    createdAt: scheduledTime || "",
  };

  // Map through the chipOptionsBodyPreview array and set values from our mapping
  const withPreview = chipOptionsBodyPreview.map((item: any) => ({
    ...item,
    previewValue:
      valueMap[item.id] !== undefined ? valueMap[item.id] : item.previewValue,
  }));
  return applyFlowToChips(withPreview, flow);
};

export const onBoardingOptionsIds = [
  "address1",
  "brandName",
  "companyName",
  "country",
  "state",
  "userName",
];

// Portal and app link chip IDs for CUSTOMER_USER_VERIFIED
export const portalAppLinkIds = [
  "vanityCustomerPortalUrl",
  "teamsAppLink",
  "iOSAppLink",
  "androidAppLink",
  "windowsAppDownloadLink",
  "macOSAppDownloadLink",
];

export const onBoradingTemplateOptions = ({
  editorFiled,
  serviceSubType,
}: {
  editorFiled: string;
  serviceSubType: string;
}) => {
  const allowedRedirectLinkAndButtonList = [
    "RESOURCE_INVITATION",
    "CUSTOMER_USER_INVITATION",
    "CUSTOMER_USER_PASSWORD_RESET",
    "RESET_PASSWORD_MSP",
    "RESOURCE_SIGN_IN",
    "CUSTOMER_USER_SIGN_IN",
  ];

  const onBoardingAdditionalBodyOptions = [
    {
      id: "redirectButton",
      label: "Link button",
      value: "redirect-button",
      bgColor: "rgb(85, 99, 245)",
      fontColor: "rgba(255, 255, 255, 1)",
    },
    { id: "redirectUrl", label: "Redirect link", value: "redirect-url" },
  ];

  // ServiceSubTypes that need verificationCode chip
  const serviceSubTypesWithVerificationCode = [
    "RESOURCE_SIGN_IN",
    "CUSTOMER_USER_SIGN_IN",
    "RESET_PASSWORD_MSP",
    "CUSTOMER_USER_PASSWORD_RESET",
  ];

  const returnButtonAndLink =
    allowedRedirectLinkAndButtonList.includes(serviceSubType);

  // Special handling for CUSTOMER_USER_VERIFIED in body field
  if (editorFiled === "body" && serviceSubType === "CUSTOMER_USER_VERIFIED") {
    return [
      ...chipOptionsBody.filter((option) =>
        onBoardingOptionsIds.includes(option.id),
      ),
      ...chipOptionsBody.filter((option) =>
        portalAppLinkIds.includes(option.id),
      ),
    ].sort((a, b) => a.label.localeCompare(b.label));
  }

  if (editorFiled === "body" && returnButtonAndLink) {
    if (serviceSubTypesWithVerificationCode.includes(serviceSubType)) {
      // Base options with verificationCode
      const baseOptions = chipOptionsBody.filter((option) =>
        [...onBoardingOptionsIds, "verificationCode"].includes(option.id),
      );

      // Add redirect button and link for invitation types
      if (
        serviceSubType === "RESOURCE_INVITATION" ||
        serviceSubType === "CUSTOMER_USER_INVITATION"
      ) {
        return [...baseOptions, ...onBoardingAdditionalBodyOptions].sort(
          (a, b) => a.label.localeCompare(b.label),
        );
      }

      // For other types (Sign-in and Password Reset), just return base options (includes verification code)
      return baseOptions.sort((a, b) => a.label.localeCompare(b.label));
    } else {
      // For other types in allowedRedirectLinkAndButtonList
      return [
        ...chipOptionsBody.filter((option) =>
          onBoardingOptionsIds.includes(option.id),
        ),
        ...onBoardingAdditionalBodyOptions,
      ].sort((a, b) => a.label.localeCompare(b.label));
    }
  } else {
    // For subject field
    return chipOptionsSubject
      .filter((option) => onBoardingOptionsIds.includes(option.id))
      .sort((a, b) => a.label.localeCompare(b.label));
  }
};

//--------------------------old code--------------------------------
// export const onBoradingTemplateOptions = ({
//   editorFiled,
//   serviceSubType,
// }: {
//   editorFiled: string;
//   serviceSubType: string;
// }) => {
//   const allowedRedirectLinkAndButtonList = [
//     "RESOURCE_INVITATION",
//     "CUSTOMER_USER_INVITATION",
//     "CUSTOMER_USER_PASSWORD_RESET",
//     "RESET_PASSWORD_MSP",
//   ];

//   const onBoardingAdditionalBodyOptions = [
//     {
//       id: "redirectButton",
//       label: "Link button",
//       value: "redirect-button",
//       bgColor: "rgb(85, 99, 245)",
//       fontColor: "rgba(255, 255, 255, 1)",
//     },
//     { id: "redirectUrl", label: "Redirect link", value: "redirect-url" },
//   ];
//   const onBoardingOptionsIds = [
//     "address1",
//     "brandName",
//     "companyName",
//     "country",
//     "state",
//     "userName",
//   ];
//   const returnButtonAndLink =
//     allowedRedirectLinkAndButtonList.includes(serviceSubType);
//   if (editorFiled === "body" && returnButtonAndLink) {
//     return [
//       ...chipOptionsBody.filter((option) =>
//         onBoardingOptionsIds.includes(option.id)
//       ),
//       ...onBoardingAdditionalBodyOptions,
//     ].sort((a, b) => a.label.localeCompare(b.label));
//   } else {
//     return chipOptionsSubject
//       .filter((option) => onBoardingOptionsIds.includes(option.id))
//       .sort((a, b) => a.label.localeCompare(b.label));
//   }
// };

//----------------------------------------------------------

// export const chipOptionsSubjectPreview = [
//   {
//     id: "serviceUId",
//     label: "ID Number",
//     value: "service-id",
//     previewValue: "ST**********00001",
//   },
//   {
//     id: "serviceSummary",
//     label: "Summary",
//     value: "service-summary",
//     previewValue: "Unable to connect to VPN",
//   },
//   {
//     id: "description",
//     label: "Description",
//     value: "description",
//     previewValue:
//       "User is unable to connect to the corporate VPN from home. Issue started after a recent system update. Verified network settings, but the problem persists.",
//   },
//   {
//     id: "customerName",
//     label: "Customer name",
//     value: "customer-name",
//     previewValue: "Alpax Solutions Inc.",
//   },
//   {
//     id: "customerCode",
//     label: "Customer Code",
//     value: "customer-code",
//     previewValue: "ALPAX0002",
//   },
//   {
//     id: "userName",
//     label: "Username",
//     value: "user-name",
//     previewValue: "John Miller",
//   },
//   // { id: "status", label: "Status", value: "status", previewValue: "Critical" },
//   {
//     id: "oldStatus",
//     label: "Old Status",
//     value: "old-status",
//     previewValue: "New",
//   },
//   {
//     id: "newStatus",
//     label: "New Status",
//     value: "new-status",
//     previewValue: "Assigned",
//   },
//   {
//     id: "assignee",
//     label: "Assignee",
//     value: "assignee",
//     previewValue: "Emma Thomas",
//   },
//   {
//     id: "teamMember",
//     label: "Added by Teammate",
//     value: "team-member",
//     previewValue: "Michael James",
//   },
//   {
//     id: "priority",
//     label: "Priority",
//     value: "priority",
//     previewValue: "Critical",
//   },
//   {
//     id: "tag",
//     label: "Tag",
//     value: "tag",
//     previewValue: "VPN, Remote Access, Connectivity",
//   },
//   {
//     id: "source",
//     label: "Source",
//     value: "source",
//     previewValue: "IT-Connect Mobile",
//   },
//   { id: "impact", label: "Impact", value: "impact", previewValue: "High" },
//   { id: "urgency", label: "Urgency", value: "urgency", previewValue: "High" },
//   {
//     id: "workType",
//     label: "Work Type",
//     value: "work-type",
//     previewValue: "Remote",
//   },
//   {
//     id: "workRole",
//     label: "Work Role",
//     value: "work-role",
//     previewValue: "Technician",
//   },
//   {
//     id: "serviceAge",
//     label: "Age",
//     value: "service-age",
//     previewValue: "10 hours 3 mins",
//   },
//   {
//     id: "createdAt",
//     label: "Created Time",
//     value: "created-at",
//     previewValue: "Current date and time",
//   },
//   {
//     id: "slaName",
//     label: "SLA Name",
//     value: "sla-name",
//     previewValue: "Standard Remote SLA - Critical",
//   },
//   {
//     id: "contractName",
//     label: "Contract Name",
//     value: "contract-name",
//     previewValue: "Alpax Annual Remote Support",
//   },
//   {
//     id: "serviceOwner",
//     label: "Service Owner",
//     value: "service-owner",
//     previewValue: "Sophia Jones",
//   },
//   {
//     id: "budgetedHours",
//     label: "Budgeted Hours",
//     value: "budgeted-hours",
//     previewValue: "3 hours",
//   },
//   {
//     id: "location",
//     label: "Location",
//     value: "location",
//     previewValue: "New York",
//   },
//   {
//     id: "serviceType",
//     label: "Type",
//     value: "service-type",
//     previewValue: "Network",
//   },
//   {
//     id: "serviceSubType",
//     label: "SubType",
//     value: "service-sub-type",
//     previewValue: "VPN Issue",
//   },
//   {
//     id: "serviceEndTime",
//     label: "Estimated End time",
//     value: "service-end-time",
//     previewValue: "Current date and time",
//   },
//   {
//     id: "serviceHealth",
//     label: "Health",
//     value: "service-health",
//     previewValue: "Passed",
//   },
//   {
//     id: "billableStatus",
//     label: "Billable Status",
//     value: "billable-status",
//     previewValue: "Billable",
//   },
//   {
//     id: "note",
//     label: "Added note",
//     value: "note",
//     previewValue:
//       "**User reported an inability to connect to the corporate VPN after a recent update. Basic troubleshooting steps such as verifying login credentials, resetting the router, and checking firewall settings were performed. VPN configuration file was reinstalled, and a manual DNS update was applied. User has been advised to restart the system and confirm if the issue is resolved. Awaiting final confirmation.",
//   },
//   {
//     id: "chatMessage",
//     label: "Chat Message",
//     value: "chat-message",
//     previewValue: "Still can't access the VPN after restart.",
//   },
//   {
//     id: "companyName",
//     label: "Company name",
//     value: "company-name",
//     previewValue: "",
//   },
//   {
//     id: "brandName",
//     label: "Brand name",
//     value: "brand-name",
//     previewValue: "Company Brand Name", //fetch real data
//   },
//   {
//     id: "address1",
//     label: "Address",
//     value: "address1",
//     previewValue: "Company Address", // fetch real data
//   },
//   {
//     id: "address2",
//     label: "Address line 2",
//     value: "address2",
//     previewValue: "",
//   },
//   {
//     id: "country",
//     label: "Country",
//     value: "country",
//     previewValue: "country", // fetch real data
//   },
//   { id: "state", label: "State", value: "state", previewValue: "State" }, // fetcch real data
//   {
//     id: "companyLogo",
//     label: "Company logo",
//     value: "company-logo",
//     previewValue: "",
//   },

//   { id: "sender", label: "Sender", value: "sender", previewValue: "Sender" }, // fetch real data

//   {
//     id: "scheduledTime",
//     label: "Scheduled Time",
//     value: "scheduled-time",
//     previewValue: "", // current time
//   },
// ];

// Customer Name
// Placeholder: {{customer_name}}
// Example: "Dear {{customer_name}}, your invoice is ready."
// Invoice Number
// Placeholder: {{invoice_number}}
// Example: "Invoice #{{invoice_number}}"
// Invoice Date
// Placeholder: {{invoice_date}}
// Example: "Issued on {{invoice_date}}"
// Due Date
// Placeholder: {{due_date}}
// Example: "Please pay by {{due_date}}"
// Contract Name
// Placeholder: {{contract_name}}
// Example: "Under contract: {{contract_name}}"
// Pending Amount
// Placeholder: {{pending_amount}}
// Example: "Amount due: {{pending_amount}}"
// Total Amount
// Placeholder: {{total_amount}}
// Example: "Total invoice amount: {{total_amount}}"
// Billing Period
// Placeholder: {{billing_period}}
// Example: "Billing period: {{billing_period}}"
// Company Name
// Placeholder: {{company_name}}
// Example: "Thank you for choosing {{msp_name}}"
// Invoice Status
// Placeholder: {{invoice_status}}
// Example: "Status: {{invoice_status}}" (e.g., Draft, Sent, Overdue, Partially Paid, Paid)
// Currency
// Placeholder: {{currency}}
// Example: "Amount in {{currency}}"
// Invoice Type
// Placeholder: {{invoice_type}}
// Example: "Invoice type: {{invoice_type}}" (e.g., Recurring, Ad-hoc)
// Billing Contact Name
// Placeholder: {{billing_contact_name}}
// Example: "Attention: {{billing_contact_name}}"
// Customer Address
// Placeholder: {{customer_address}}
// Example: "Address: {{customer_address}}"
// Contract Type
// Placeholder: {{contract_type}}
// Example: "Contract type: {{contract_type}}" (e.g., Pre-Paid Hours, Block Hours, Fixed)
// Blocks (if applicable for block hours)
// Placeholder: {{blocks}}
// Example: "Blocks added: {{blocks}}"

export const billingTemplateOptions = [
  /* 1. Status */
  {
    id: "status",
    label: "Status",
    value: "status",
    previewValue: "Draft",
  },

  /* 2. Customer Name */
  {
    id: "customerName",
    label: "Customer name",
    value: "customer-name",
    previewValue: "Alpax Solutions Inc.",
  },

  /* 3. Invoice Number */
  {
    id: "invoiceNumber",
    label: "Invoice number",
    value: "invoice-number",
    previewValue: "INV00001",
  },

  /* 4. Invoice Date */
  {
    id: "invoiceDate",
    label: "Invoice date",
    value: "invoice-date",
    previewValue: "01/01/2022",
  },

  /* 5. Due Date */
  {
    id: "dueDate",
    label: "Due date",
    value: "due-date",
    previewValue: "01/15/2022",
  },

  /* 6. Pending Amount */
  {
    id: "pendingAmount",
    label: "Pending amount",
    value: "pending-amount",
    previewValue: "$100",
  },

  /* 7. Total Amount */
  {
    id: "totalAmount",
    label: "Total amount",
    value: "total-amount",
    previewValue: "$100",
  },

  /* Paid Date */
  {
    id: "paidDate",
    label: "Paid date",
    value: "paid-date",
    previewValue: "29 Jan 2026",
  },

  /* Paid Amount */
  {
    id: "paidAmount",
    label: "Paid amount",
    value: "paid-amount",
    previewValue: "$500",
  },


  /* 9. Phone Number */ // comment for issue 4429
  // {
  //   id: "phoneNumber",
  //   label: "Phone Number",
  //   value: "phone-number",
  //   previewValue: "(+1) 123-456-7890",
  // },

  /* 10. Company Name */
  {
    id: "companyName",
    label: "Company name",
    value: "company-name",
    previewValue: "Alpax Solutions Inc.",
  },

  /* 11. Brand Name */
  {
    id: "brandName",
    label: "Brand name",
    value: "brand-name",
    previewValue: "Alpax",
  },

  /* 12. Address Line 1 */
  {
    id: "address1",
    label: "Address line 1",
    value: "address-1",
    previewValue: "123 Main St",
  },

  /* 13. Address Line 2 */
  {
    id: "address2",
    label: "Address line 2",
    value: "address-2",
    previewValue: "Suite 04",
  },

  /* 14. Country */
  {
    id: "country",
    label: "Country",
    value: "country",
    previewValue: "USA",
  },

  /* 15. State / Province */
  {
    id: "state",
    label: "State",
    value: "state",
    previewValue: "California",
  },

  /* 16. Business Email */
  {
    id: "businessEmail",
    label: "Business email",
    value: "business-email",
    previewValue: "billing@alpax.com",
  },

  /* 17. Company Logo */ // comment for issue 4429
  // {
  //   id: "companyLogo",
  //   label: "Company logo",
  //   value: "company-logo",
  //   previewValue: "ALPAX LOGO",
  // },
  {
    id: "paymentLink",
    label: "Payment link",
    value: "payment-link",
    previewValue: "deskday.ai/pay-now",
  },
  {
    id: "paymentButton",
    label: "Pay now button",
    value: "payment-button",
    previewValue: "Pay now",
  },
];

// export const billingTemplateOptions = [
//   {
//     id: "customerName",
//     label: "Customer name",
//     value: "customer-name",
//     previewValue: "Alpax Solutions Inc.",
//   },
//   {
//     id: "invoiceNumber",
//     label: "Invoice number",
//     value: "invoice-number",
//     previewValue: "INV00001",
//   },
//   {
//     id: "invoiceDate",
//     label: "Invoice date",
//     value: "invoice-date",
//     previewValue: "01/01/2022",
//   },
//   {
//     id: "dueDate",
//     label: "Due date",
//     value: "due-date",
//     previewValue: "01/01/2022",
//   },
//   {
//     id: "contractName",
//     label: "Contract Name",
//     value: "contract-name",
//     previewValue: "Alpax Annual Remote Support",
//   },
//   {
//     id: "pendingAmount",
//     label: "Pending amount",
//     value: "pending-amount",
//     previewValue: "$100",
//   },
//   {
//     id: "totalAmount",
//     label: "Total amount",
//     value: "total-amount",
//     previewValue: "$100",
//   },
//   {
//     id: "billingPeriod",
//     label: "Billing Period",
//     value: "billing-period",
//     previewValue: "01/01/2022 - 01/01/2022",
//   },
//   {
//     id: "companyName",
//     label: "Company name",
//     value: "company-name",
//     previewValue: "Alpax Solutions Inc.",
//   },
//   {
//     id: "invoiceStatus",
//     label: "Invoice Status",
//     value: "invoice-status",
//     previewValue: "Draft",
//   },
//   {
//     id: "currency",
//     label: "Currency",
//     value: "currency",
//     previewValue: "USD",
//   },
//   {
//     id: "invoiceType",
//     label: "Invoice type",
//     value: "invoice-type",
//     previewValue: "Recurring",
//   },
//   {
//     id: "billingContactName",
//     label: "Billing Contact Name",
//     value: "billing-contact-name",
//     previewValue: "John Doe",
//   },
//   {
//     id: "customerAddress",
//     label: "Customer Address",
//     value: "customer-address",
//     previewValue: "123 Main St, Anytown, USA",
//   },
//   {
//     id: "contractType",
//     label: "Contract Type",
//     value: "contract-type",
//     previewValue: "Pre-Paid Hours",
//   },
//   {
//     id: "blocks",
//     label: "Blocks",
//     value: "blocks",
//     previewValue: "10",
//   },
// ];
